import axios from "axios";

export default {
  methods: {
    /**
     * Retorna as opções de relatório disponiveis para o usuario atual
     * @return {
     * [
     *    {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    }
     *  ]
     * }
     */
    getRelatorioOpcoes() {
      return axios.get(
        this.CriarUrl(
          {
            resource: "relatorios/opcoes"
          },
          { apiRelatorio: true }
        )
      );
    }
  }
};
